import axios from "axios";
import $ from 'jquery'
import { setTimeout } from "timers";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken, EmulatedProductData } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_UNPROCESSED_RECORDS = false

/*
 * Unprocessed Records Actions
 * 
 */

export function fetchUnprocessedRecordsList(dispatch, filteredparams) {

    let cmd = 'FETCH_UNPROCESSED_RECORDS'

    if (EMULATION_ALL || EMULATION_MODE_UNPROCESSED_RECORDS) {
        dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            manufacturerCodes: [
                                "BAL"
                            ],
                            productLines: [
                                "BA",
                                "RO"
                            ],
                            unprocessedRecords: [
                                {
                                    productTemplateId: 0,
                                    id: 1,
                                    supplementalDataMissing: false,
                                    brprid: 1001,
                                    brmfg: "BAL",
                                    brlin: "BA",
                                    brpart: "PT",
                                    brdeS1: "BALLY GOOD STUFF",
                                    brdeS2: "",
                                    brdeS3: "",
                                    brdisc: false,
                                    brdir: true,
                                    brpub: true,
                                    brstkspr: true,
                                    brstkelk: true,
                                    brstkral: false,
                                    brupc: "45678901",
                                    brmsrp: 16.95,
                                    brcost: 8.25,
                                    brweight: 0,
                                    brcubes: 0,
                                    brprcod: 780,
                                    brqtyaspr: 0,
                                    brqtyaelk: 3,
                                    brqtyaral: 0,
                                    brldtm: "2018-08-27T19:00:43",
                                    brlpgm: "SFPR110",
                                    brluser: "RESTES",
                                    manufacturerCodes: null,
                                    productLines: null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 3,
                                    "supplementalDataMissing": true,
                                    "brprid": 1003,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "108SPLASH",
                                    "brdeS1": "OAK BACKSPLASH 108",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "78901084",
                                    "brmsrp": 108.45,
                                    "brcost": 52.77,
                                    "brweight": 12,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 5,
                                    "supplementalDataMissing": true,
                                    "brprid": 1005,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "120SPLASH",
                                    "brdeS1": "OAK BACKSPLASH 120",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "78901204",
                                    "brmsrp": 121.52,
                                    "brcost": 59.13,
                                    "brweight": 13,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 7,
                                    "supplementalDataMissing": true,
                                    "brprid": 1007,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "144SPLASH",
                                    "brdeS1": "OAK BACKSPLASH 144",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "78901444",
                                    "brmsrp": 176.39,
                                    "brcost": 85.83,
                                    "brweight": 16,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 9,
                                    "supplementalDataMissing": true,
                                    "brprid": 1009,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "18SPLASH",
                                    "brdeS1": "OAK BACKSPLASH 18",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "78901184",
                                    "brmsrp": 13.42,
                                    "brcost": 6.53,
                                    "brweight": 2,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 11,
                                    "supplementalDataMissing": true,
                                    "brprid": 1011,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "24SPLASH",
                                    "brdeS1": "OAK BACKSPLASH 24",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "78901244",
                                    "brmsrp": 17.69,
                                    "brcost": 8.61,
                                    "brweight": 3,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 13,
                                    "supplementalDataMissing": true,
                                    "brprid": 1013,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X108",
                                    "brdeS1": "OAK TOP 25X108 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23410825",
                                    "brmsrp": 466.83,
                                    "brcost": 227.16,
                                    "brweight": 113,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 16,
                                    "supplementalDataMissing": true,
                                    "brprid": 1016,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X120",
                                    "brdeS1": "OAK TOP 25X120 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23412025",
                                    "brmsrp": 518.56,
                                    "brcost": 252.33,
                                    "brweight": 125,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 18,
                                    "supplementalDataMissing": true,
                                    "brprid": 1018,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X144",
                                    "brdeS1": "OAK TOP 25X144 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23414425",
                                    "brmsrp": 723.22,
                                    "brcost": 351.92,
                                    "brweight": 150,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 21,
                                    "supplementalDataMissing": true,
                                    "brprid": 1021,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X18",
                                    "brdeS1": "OAK TOP 25X18 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23451825",
                                    "brmsrp": 74.21,
                                    "brcost": 36.11,
                                    "brweight": 19,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 23,
                                    "supplementalDataMissing": true,
                                    "brprid": 1023,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X24",
                                    "brdeS1": "OAK TOP 25X24 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23452425",
                                    "brmsrp": 98.87,
                                    "brcost": 48.11,
                                    "brweight": 25,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 25,
                                    "supplementalDataMissing": true,
                                    "brprid": 1025,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X30",
                                    "brdeS1": "OAK TOP 25X30 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23453025",
                                    "brmsrp": 123.3,
                                    "brcost": 60,
                                    "brweight": 31,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 27,
                                    "supplementalDataMissing": true,
                                    "brprid": 1027,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X36",
                                    "brdeS1": "OAK TOP 25X36 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23453625",
                                    "brmsrp": 148.23,
                                    "brcost": 72.13,
                                    "brweight": 37,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 29,
                                    "supplementalDataMissing": true,
                                    "brprid": 1029,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X42",
                                    "brdeS1": "OAK TOP 25X42 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23454225",
                                    "brmsrp": 172.85,
                                    "brcost": 84.11,
                                    "brweight": 44,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 31,
                                    "supplementalDataMissing": true,
                                    "brprid": 1031,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X48",
                                    "brdeS1": "OAK TOP 25X48 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23454825",
                                    "brmsrp": 197.6,
                                    "brcost": 96.15,
                                    "brweight": 50,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 33,
                                    "supplementalDataMissing": true,
                                    "brprid": 1033,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X60",
                                    "brdeS1": "OAK TOP 25X60 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23456025",
                                    "brmsrp": 247.12,
                                    "brcost": 120.25,
                                    "brweight": 62,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 35,
                                    "supplementalDataMissing": true,
                                    "brprid": 1035,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X72",
                                    "brdeS1": "OAK TOP 25X72 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23457225",
                                    "brmsrp": 296.47,
                                    "brcost": 144.26,
                                    "brweight": 75,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 37,
                                    "supplementalDataMissing": true,
                                    "brprid": 1037,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X84",
                                    "brdeS1": "OAK TOP 25X84 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23458425",
                                    "brmsrp": 345.7,
                                    "brcost": 168.22,
                                    "brweight": 87,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 39,
                                    "supplementalDataMissing": true,
                                    "brprid": 1039,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "25X96",
                                    "brdeS1": "OAK TOP 25X96 X 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23459625",
                                    "brmsrp": 395.15,
                                    "brcost": 192.28,
                                    "brweight": 100,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 41,
                                    "supplementalDataMissing": true,
                                    "brprid": 1041,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "30SPLASH",
                                    "brdeS1": "OAK BACKSPLASH 30",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "78901304",
                                    "brmsrp": 22.13,
                                    "brcost": 10.77,
                                    "brweight": 4,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 43,
                                    "supplementalDataMissing": true,
                                    "brprid": 1043,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "30X120",
                                    "brdeS1": "OAK TOP 30X120 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23412030",
                                    "brmsrp": 740.14,
                                    "brcost": 360.15,
                                    "brweight": 175,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 45,
                                    "supplementalDataMissing": true,
                                    "brprid": 1045,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "30X48",
                                    "brdeS1": "OAK TOP 30X48 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23454830",
                                    "brmsrp": 284.53,
                                    "brcost": 138.45,
                                    "brweight": 70,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 47,
                                    "supplementalDataMissing": true,
                                    "brprid": 1047,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "30X60",
                                    "brdeS1": "OAK TOP 30X60 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23456030",
                                    "brmsrp": 352.47,
                                    "brcost": 171.51,
                                    "brweight": 88,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                },
                                {
                                    "productTemplateId": 5,
                                    "id": 49,
                                    "supplementalDataMissing": true,
                                    "brprid": 1049,
                                    "brmfg": "BAL",
                                    "brlin": "RO",
                                    "brpart": "30X72",
                                    "brdeS1": "OAK TOP 30X72 1 1/2",
                                    "brdeS2": "",
                                    "brdeS3": "",
                                    "brdisc": false,
                                    "brdir": false,
                                    "brpub": false,
                                    "brstkspr": false,
                                    "brstkelk": false,
                                    "brstkral": false,
                                    "brupc": "23457230",
                                    "brmsrp": 422.91,
                                    "brcost": 205.79,
                                    "brweight": 105,
                                    "brcubes": 0,
                                    "brprcod": 781,
                                    "brqtyaspr": 0,
                                    "brqtyaelk": 0,
                                    "brqtyaral": 0,
                                    "brldtm": "2018-08-27T19:00:43",
                                    "brlpgm": "SFPR110",
                                    "brluser": "RESTES",
                                    "manufacturerCodes": null,
                                    "productLines": null
                                }
                            ]
                        }
                    ]
                }
            }
        )
    }
    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: {
                            page: filteredparams && filteredparams.pageIndex ? filteredparams.pageIndex : 1
                        }
                    }
                }
            )

            var stringify = {};
            if (JSON.stringify(filteredparams) !== undefined) {
                stringify = filteredparams;
            }

            axios.post(buildRequestUrl('UnprocessedRecords'), JSON.stringify(stringify), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp

                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchUnprocessedRecordsPublishedTemplateList(dispatch, filteredparams) {

    let cmd = 'FETCH_UNPROCESSED_RECORDS'

    if (EMULATION_ALL || EMULATION_MODE_UNPROCESSED_RECORDS) {
        console.log("Testing...");
    }
    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: {
                            page: filteredparams && filteredparams.pageIndex ? filteredparams.pageIndex : 1
                        }
                    }
                }
            )

            var stringify = {};
            if (JSON.stringify(filteredparams).indexOf("listTypeFilter") >= 0) {
                stringify = filteredparams;
            }

            axios.post(buildRequestUrl('UnprocessedRecords_Published_Templates'), JSON.stringify(stringify), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchUnprocessedRecordsUnpublishedTemplateList(dispatch, filteredparams) {

    let cmd = 'FETCH_UNPROCESSED_RECORDS'

    if (EMULATION_ALL || EMULATION_MODE_UNPROCESSED_RECORDS) {
        console.log("TEST");
    }
    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: {
                            page: filteredparams && filteredparams.pageIndex ? filteredparams.pageIndex : 1
                        }
                    }
                }
            )

            var stringify = {};

            if (JSON.stringify(filteredparams).indexOf("listTypeFilter") >= 0) {
                stringify = filteredparams;
            }

            axios.post(buildRequestUrl('UnprocessedRecords_Unpublished_Templates'), JSON.stringify(stringify), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchUnprocessedRecordsError(dispatch) {

    dispatch(
        {
            type: 'FETCH_UNPROCESSED_RECORDS_ERROR',
        }
    )
}

export function process_filter(dispatch, filter) {

    dispatch(
        {
            type: "PROCESS_FILTER_SELECTION",
            payload: {
                data: filter
            }
        }
    )
}

export function show_all_records(dispatch, showAll) {
    dispatch(
        {
            type: "SHOW_ALL_RECORDS",
            payload: {
                data: showAll
            }
        }
    )
}

export function sort_records(dispatch, records_list) {
    dispatch(
        {
            type: "SORT_ALL_RECORDS",
            payload: {
                data: records_list
            }
        }
    )
}

export function export_complete(dispatch) {
    dispatch(
        {
            type: "FINISH_EXPORT",
            payload: {
                data: 100 // BBS DDD Speculating that 100 is the correct data to put in the payload
            }
        }
    )
}

export function import_excel_unprocessedrecords(dispatch, user, filter, callback) {
    $('#unprocessedRecords *').prop('disabled', true);

    let cmd = 'FETCH_UNPROCESSED_RECORDS';

    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd,
                payload: {
                    data: {
                        page: filter && filter.pageIndex ? filter.pageIndex : 1
                    }
                }
            }
        )

        dispatch(
            {
                type: 'IMPORT_START',
                payload: {
                    data: false
                }
            }
        )

        let percComplete = 0;
        dispatch(
            {
                type: 'PERCENTAGE_COMPLETE',
                payload: {
                    data: percComplete
                }
            }
        )

        var formData = new FormData();
        formData.append("username", user);
        formData.append("filename", "");
        formData.append('importFile', filter);

        axios.post(buildRequestUrl('UnprocessedRecords_Import'), formData,
            {
                responseType: 'json',
                headers: { 'content-type': 'multipart/form-data', 'Authorization': 'Bearer ' + token },
                onUploadProgress: progressEvent => {
                    let percComplete = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    dispatch(
                        {
                            type: 'PERCENTAGE_COMPLETE',
                            payload: {
                                data: percComplete
                            }
                        }
                    )
                }
            })
            .then((response) => {
                $('#unprocessedRecords *').prop('disabled', false);

                dispatch(
                    {
                        type: 'FINISH_IMPORT',
                        payload: {
                            data: 100 // percComplete
                        }
                    }
                )

                dispatch(
                    {
                        type: 'COMPLETE_IMPORT',
                        payload: {
                            data: false
                        }
                    }
                )

                if (response.status == 200) {
                    dispatch(
                        {
                            type: 'IMPORT_INFO',
                            payload: {
                                data: {
                                    jobId: response.data["backgroundJobId"],
                                    title: 'Unprocessed Records Import',
                                    status: response.data["statusMessage"]
                                }
                            }
                        }
                    )

                    var jobLink = '<a href="/prod-mgmt/jobslist/' + response.data["backgroundJobId"] + '" target="_blank">#' + response.data["backgroundJobId"] + '</a>';
                    var message = "Import background job " + jobLink + " successfully added to the queue.";
                    document.getElementById("success_modal_text").innerHTML = message;
                    setTimeout(document.getElementById("myBtnSuccess").click(), 1000);
                }
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
            .finally(() => {
                // Reset the UI

                setTimeout("document.getElementById('startImport').style.display = 'none';", 1000);
                document.getElementById("fileChooseButton").value = null;
                $('#unprocessedRecords *').prop('disabled', false);
            })
    })


}

export function export_excel_unprocessedrecords(dispatch, user, filters, callback) {
    $('#unprocessedRecords *').prop('disabled', true);
    let cmd = 'FETCH_UNPROCESSED_RECORDS';

    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd,
                payload: {
                    data: {
                        page: filters && filters.pageIndex ? filters.pageIndex : 1
                    }
                }
            }
        )

        var requestParams = {
            username: user,
            listTypeFilter: filters["listTypeFilter"],
            unpublishedTemplateFilter: filters["unpublishedTemplateFilter"],
            publishedTemplateFilter: filters["publishedTemplateFilter"],
            manufacturerFilter: filters["manufacturerFilter"],
            productLineFilter: filters["productLineFilter"],
            partFilter: filters["partFilter"],
            descriptionFilter: filters["descriptionFilter"]
        };

        dispatch(
            {
                type: 'EXPORT_START',
                payload: {
                    data: false
                }
            }
        )

        let percComplete = 0;
        dispatch(
            {
                type: 'PERCENTAGE_COMPLETE',
                payload: {
                    data: percComplete
                }
            }
        )

        document.getElementById("startExport").style.display = "inline";
        console.log(requestParams);
        axios.post(buildRequestUrl('UnprocessedRecords_ExportBG'), JSON.stringify(requestParams),
            {
                responseType: 'json',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                onDownloadProgress: progressEvent => {
                    dispatch(
                        {
                            type: 'FINISH_EXPORT',
                            payload: {
                                data: 100 // percentComplete
                            }
                        }
                    )

                    dispatch(
                        {
                            type: 'COMPLETE_EXPORT',
                            payload: {
                                data: true
                            }
                        }
                    )
                }
            })
            .then((response) => {
                if (response.status == 200) {
                    $('#unprocessedRecords *').prop('disabled', false);
                    dispatch(
                        {
                            type: 'COMPLETE_EXPORT',
                            payload: {
                                data: false
                            }
                        }
                    )

                    //TODO
                    dispatch(
                        {
                            type: 'EXPORT_INFO',
                            payload: {
                                data: {
                                    jobId: response.data["backgroundJobId"],
                                    title: 'Unprocessed Records Export',
                                    status: response.data["statusMessage"]
                                }
                            }
                        }
                    )

                    var jobLink = '<a href="/prod-mgmt/jobslist/' + response.data["backgroundJobId"] + '" target="_blank">#' + response.data["backgroundJobId"] + '</a>';
                    var message = "Export background job " + jobLink + " successfully added to the queue.";
                    document.getElementById("success_modal_text").innerHTML = message;
                    setTimeout(document.getElementById("myBtnSuccess").click(), 1000);
                }

            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
            .finally(() => {
                $('#unprocessedRecords *').prop('disabled', false);
                setTimeout("document.getElementById('startExport').style.display = 'none';", 1000);
            })
    })
}

export function clear_export(dispatch) {
    dispatch(
        {
            type: 'CLEAR_EXPORT'
        }
    )
}

export function sortUnprocessedRecords(dispatch, recordsList, col, asc) {
    dispatch(
        {
            type: "SORT_" + col.toUpperCase(),
            payload: {
                data: asc,
                list: recordsList
            }
        }
    )
}

export function reprocessImport(user, jobid) {
    let cmd = 'REPROCESS_IMPORT'

    if (EMULATION_ALL || EMULATION_MODE_UNPROCESSED_RECORDS)
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: "Fulfilled"
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: ""
                    }
                }
            )

            // get filename
            axios.post(buildRequestUrl('UnprocessedRecords_GetReProcessFileName/') + jobid, {}, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((rsp) => {
                    // get file
                    axios.get(buildRequestUrl('BackgroundJobs/File/') + jobid, { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }, responseType: 'blob' })
                        .then((rsp2) => {
                            var filepos = rsp.data.split('\\').length - 1
                            var filename = rsp.data.split('\\')[filepos]

                            var formData = new FormData();
                            formData.append("username", user);
                            formData.append("filename", filename);
                            formData.append("importFile", rsp2.data);

                            axios.post(
                                buildRequestUrl('UnprocessedRecords_Import'),
                                formData,
                                { responseType: 'json', headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token } })
                                .then((rsp3) => {
                                    dispatch(
                                        {
                                            type: cmd + '_FULFILLED',
                                            payload: {
                                                data: {
                                                    statusMessage: 'Import background job <a href="/prod-mgmt/jobslist/' + rsp3.data["backgroundJobId"] + '" target="_blank">#' + rsp3.data["backgroundJobId"] + '</a>  successfully added to the queue.'
                                                 }
                                            }
                                        }
                                    )
                                })
                                .catch((err) => {
                                    dispatch(
                                        {
                                            type: cmd + '_REJECTED',
                                            payload: err
                                        }
                                    )
                                })
                        })
                        .catch((err) => {
                            dispatch(
                                {
                                    type: cmd + '_REJECTED',
                                    payload: err
                                }
                            )
                        })
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}